import React, { useCallback, useMemo } from "react";
import { useStore } from "stores/connect";
import ExpandedConfigurationSection from "./expanded-sections/ExpandedConfigurationSection";
import ForwarderInputTypesStore from "../stores/ForwarderInputTypesStore";
const useTableElements = () => {
  const { forwarderInputDescriptions } = useStore(ForwarderInputTypesStore);
  const renderExpandedConfigurationDetails = useCallback(
    (input) => /* @__PURE__ */ React.createElement(ExpandedConfigurationSection, { input, inputDescriptions: forwarderInputDescriptions }),
    [forwarderInputDescriptions]
  );
  const expandedSections = useMemo(
    () => ({
      configuration: {
        title: "Configuration",
        content: renderExpandedConfigurationDetails
      }
    }),
    [renderExpandedConfigurationDetails]
  );
  return { expandedSections };
};
export default useTableElements;
